module.exports = __webpack_public_path__ + "img/haibao.fb1fac28.jpg";